import { put } from 'redux-saga/effects';
import TagsActions from '../redux/TagsRedux';
import i18n from '../i18n';

export function* getPersonTags(api, { personId, customerId, pageParams }) {
  try {
    const getPersonTagsResponse = yield api.getPersonTags(personId, customerId, pageParams);
    console.log('getPersonTagsResponse:', getPersonTagsResponse);
    if (getPersonTagsResponse.ok) {
      const getPersonTagsResponseData = getPersonTagsResponse.data.content.map((tag) => {
        return {
          ...tag,
          accesslevels: Array.from(new Set(tag.accesslevels.map(a => a.accessLevelId)))
            .map(accessLevelId => {
              return tag.accesslevels.find(a => a.accessLevelId === accessLevelId)
            })
        }
      });
      yield put(
        TagsActions.getPersonTagsRequestSuccess(
          getPersonTagsResponseData,
          getPersonTagsResponse.data.totalElements
        )
      );
    } else {
      api.checkAuth(getPersonTagsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getPersonTagsResponse.problem !== 'undefined'
          ? getPersonTagsResponse.problem
          : typeof getPersonTagsResponse.data.error !== 'undefined'
            ? getPersonTagsResponse.data.error
            : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagsActions.getPersonTagsRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagsActions.getPersonTagsRequestFailure(error));
  }
}

export function* createPersonTag(api, { tagInfos, personId, customerId, pageParams, useHID }) {
  const type = useHID ? 'hid' : '';
  try {
    const createPersonTagResponse = yield api.createPersonTag(tagInfos, type);
    console.log('createPersonTagResponse:', createPersonTagResponse);
    const getPersonTagsResponse = yield api.getPersonTags(personId, customerId, pageParams);
    const successMessage = i18n.t('successMessage.createTagSuccess');
    console.log('getPersonTagsResponse:', getPersonTagsResponse);
    if (createPersonTagResponse.ok && getPersonTagsResponse.ok) {
      yield put(
        TagsActions.createPersonTagRequestSuccess(
          getPersonTagsResponse.data.content,
          getPersonTagsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(createPersonTagResponse);
      api.checkAuth(getPersonTagsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof createPersonTagResponse.problem !== 'undefined'
          ? createPersonTagResponse.problem
          : typeof createPersonTagResponse.data.error !== 'undefined'
            ? createPersonTagResponse.data.error
            : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagsActions.createPersonTagRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagsActions.createPersonTagRequestFailure(error));
  }
}

export function* activateTag(api, { tagInfos }) {
  console.log('tagInfos:', tagInfos);
  try {
    const activateTagResponse = yield api.createPersonTag(tagInfos);
    console.log('activateTagResponse:', activateTagResponse);
    activateTagResponse.data && console.log('activateTagResponse.data:', activateTagResponse.data);
    activateTagResponse.data.message &&
      console.log('activateTagResponse.data.message:', activateTagResponse.data.message);
    const successMessage = i18n.t('successMessage.activateTagSuccess', { tagUid: tagInfos.tagUid });
    if (activateTagResponse.ok) {
      yield put(TagsActions.activateTagRequestSuccess(successMessage));
    } else {
      api.checkAuth(activateTagResponse);
      let error = i18n.t('unexpectedError');
      let errorBody = '';
      if (activateTagResponse.data && activateTagResponse.data.message) {
        errorBody = activateTagResponse.data.message;
      }
      if (errorBody) {
        error = errorBody;
      }
      console.log('error:', error);
      yield put(TagsActions.activateTagRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagsActions.activateTagRequestFailure(error));
  }
}

export function* editPersonTag(api, { tagId, tagInfos, personId, customerId, pageParams }) {
  try {
    const editPersonTagResponse = yield api.editPersonTag(tagId, tagInfos);
    console.log('editPersonTagResponse:', editPersonTagResponse);
    const getPersonTagsResponse = yield api.getPersonTags(personId, customerId, pageParams);
    const successMessage = i18n.t('successMessage.editTagSuccess');
    console.log('getPersonTagsResponse:', getPersonTagsResponse);
    if (editPersonTagResponse.ok && getPersonTagsResponse.ok) {
      yield put(
        TagsActions.editPersonTagRequestSuccess(
          getPersonTagsResponse.data.content,
          getPersonTagsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(editPersonTagResponse);
      api.checkAuth(getPersonTagsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editPersonTagResponse.problem !== 'undefined'
          ? editPersonTagResponse.problem
          : typeof editPersonTagResponse.data.error !== 'undefined'
            ? editPersonTagResponse.data.error
            : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagsActions.editPersonTagRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagsActions.editPersonTagRequestFailure(error));
  }
}

export function* deletePersonTag(api, { tagId, personId, customerId, pageParams }) {
  try {
    const deletePersonTagResponse = yield api.deletePersonTag(tagId);
    console.log('deletePersonTagResponse:', deletePersonTagResponse);
    const getPersonTagsResponse = yield api.getPersonTags(personId, customerId, pageParams);
    const successMessage = i18n.t('successMessage.deleteTagSuccess');
    console.log('getPersonTagsResponse:', getPersonTagsResponse);
    if (deletePersonTagResponse.ok && getPersonTagsResponse.ok) {
      yield put(
        TagsActions.deletePersonTagRequestSuccess(
          getPersonTagsResponse.data.content,
          getPersonTagsResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(deletePersonTagResponse);
      api.checkAuth(getPersonTagsResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deletePersonTagResponse.problem !== 'undefined'
          ? deletePersonTagResponse.problem
          : typeof deletePersonTagResponse.data.error !== 'undefined'
            ? deletePersonTagResponse.data.error
            : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagsActions.deletePersonTagRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagsActions.deletePersonTagRequestFailure(error));
  }
}

export function* getTagTypes(api, { customerId, pageParams }) {
  try {
    const getTagTypesResponse = yield api.getTagTypes(customerId, pageParams);
    console.log('getTagTypesResponse:', getTagTypesResponse);
    if (getTagTypesResponse.ok) {
      yield put(
        TagsActions.getTagTypesRequestSuccess(getTagTypesResponse.data.content, getTagTypesResponse.data.totalElements)
      );
    } else {
      api.checkAuth(getTagTypesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof getTagTypesResponse.problem !== 'undefined'
          ? getTagTypesResponse.problem
          : typeof getTagTypesResponse.data.error !== 'undefined'
            ? getTagTypesResponse.data.error
            : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagsActions.getTagTypesRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagsActions.getTagTypesRequestFailure(error));
  }
}

export function* createTagType(api, { tagTypeInfos, customerId, pageParams }) {
  try {
    const createTagTypeResponse = yield api.createTagType(tagTypeInfos);
    console.log('createTagTypeResponse:', createTagTypeResponse);
    const getTagTypesResponse = yield api.getTagTypes(customerId, pageParams);
    console.log('getTagTypesResponse:', getTagTypesResponse);
    const successMessage = i18n.t('successMessage.createTagType');

    if (createTagTypeResponse.ok && getTagTypesResponse.ok) {
      yield put(
        TagsActions.createTagTypeRequestSuccess(
          getTagTypesResponse.data.content,
          getTagTypesResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(createTagTypeResponse);
      api.checkAuth(getTagTypesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof createTagTypeResponse.problem !== 'undefined'
          ? createTagTypeResponse.problem
          : typeof createTagTypeResponse.data.error !== 'undefined'
            ? createTagTypeResponse.data.error
            : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagsActions.createTagTypeRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagsActions.createTagTypeRequestFailure(error));
  }
}

export function* editTagType(api, { tagTypeInfos, customerId, pageParams }) {
  try {
    const editTagTypeResponse = yield api.editTagType(tagTypeInfos);
    console.log('editTagTypeResponse:', editTagTypeResponse);
    const getTagTypesResponse = yield api.getTagTypes(customerId, pageParams);
    console.log('getTagTypesResponse:', getTagTypesResponse);
    const successMessage = i18n.t('successMessage.editTagType');

    if (editTagTypeResponse.ok && getTagTypesResponse.ok) {
      yield put(
        TagsActions.editTagTypeRequestSuccess(
          getTagTypesResponse.data.content,
          getTagTypesResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(editTagTypeResponse);
      api.checkAuth(getTagTypesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof editTagTypeResponse.problem !== 'undefined'
          ? editTagTypeResponse.problem
          : typeof editTagTypeResponse.data.error !== 'undefined'
            ? editTagTypeResponse.data.error
            : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagsActions.editTagTypeRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagsActions.editTagTypeRequestFailure(error));
  }
}

export function* deleteTagType(api, { tagTypeId, customerId, pageParams }) {
  try {
    const deleteTagTypeResponse = yield api.deleteTagType(tagTypeId);
    console.log('deleteTagTypeResponse:', deleteTagTypeResponse);
    const getTagTypesResponse = yield api.getTagTypes(customerId, pageParams);
    console.log('getTagTypesResponse:', getTagTypesResponse);
    const successMessage = i18n.t('successMessage.deleteTagType');
    console.log('successMessage:', successMessage);

    if (deleteTagTypeResponse.ok && getTagTypesResponse.ok) {
      yield put(
        TagsActions.deleteTagTypeRequestSuccess(
          getTagTypesResponse.data.content,
          getTagTypesResponse.data.totalElements,
          successMessage
        )
      );
    } else {
      api.checkAuth(deleteTagTypeResponse);
      api.checkAuth(getTagTypesResponse);
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof deleteTagTypeResponse.problem !== 'undefined'
          ? deleteTagTypeResponse.problem
          : typeof deleteTagTypeResponse.data.error !== 'undefined'
            ? deleteTagTypeResponse.data.error
            : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(TagsActions.deleteTagTypeRequestFailure(error));
    }
  } catch (error) {
    console.log('error in tags saga', error);
    yield put(TagsActions.deleteTagTypeRequestFailure(error));
  }
}
